import { IEditStoreFormData } from '@/components-latest/ui/AccountPage/EditStoreInfoForm'
import { IStoreProfileData } from '@/ducks/account/account.types'

export const mapStoreInfoToForm = (
  storeInfo: IStoreProfileData
): IEditStoreFormData => {
  const phones = storeInfo.phone

  return {
    email2: storeInfo.email2,
    store_img_name: storeInfo.store_img_name || '',
    avg_ratings: storeInfo.avg_ratings,
    address: storeInfo.address,
    email1: storeInfo.email1,
    facebook: storeInfo.facebook,
    genre: storeInfo.genre,
    inReview: storeInfo.inReview,
    support: storeInfo.support,
    store_name: storeInfo.store_name,
    website: storeInfo.website,
    phone1:
      phones.phone1?.number && phones.phone1?.country_code
        ? `${phones.phone1.country_code}${phones.phone1.number}`
        : null,
    phone2:
      phones.phone2?.number && phones.phone2?.country_code
        ? `${phones.phone2.country_code}${phones.phone2.number}`
        : null,
    phone3:
      phones.phone3?.number && phones.phone3?.country_code
        ? `${phones.phone3.country_code}${phones.phone3.number}`
        : null
  }
}
